/**
 * DeleteMailshotModal Component
 *
 * Confirmation modal for deleting mailshots
 * - Blocks deletion if mailshot contains properties
 * - Shows confirmation if mailshot is empty
 */

import React from "react";
import { FaTrash, FaExclamationTriangle } from "react-icons/fa";
import Modal from "./Modal";
import Button from "./Button";
import "./DeleteMailshotModal.scss";

const DeleteMailshotModal = ({
  isOpen,
  onClose,
  onConfirm,
  mailshotName,
  propertyCount,
  loading = false,
}) => {
  const hasProperties = propertyCount > 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={hasProperties ? "Cannot Delete Mailshot" : "Delete Mailshot"}
      icon={hasProperties ? FaExclamationTriangle : FaTrash}
      className="delete-mailshot-modal"
    >
      <div className="delete-mailshot-modal__content">
        {hasProperties ? (
          <>
            <p className="warning-message">
              <FaExclamationTriangle className="warning-icon" />
              This mailshot contains <strong>{propertyCount}</strong>{" "}
              {propertyCount === 1 ? "property" : "properties"} and cannot be
              deleted.
            </p>
            <p>
              Please remove all properties from this mailshot before attempting
              to delete it.
            </p>
          </>
        ) : (
          <>
            <p>
              Are you sure you want to delete <strong>{mailshotName}</strong>?
            </p>
            <p className="warning-text">This action cannot be undone.</p>
          </>
        )}
      </div>

      <div className="delete-mailshot-modal__actions">
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          {hasProperties ? "Close" : "Cancel"}
        </Button>
        {!hasProperties && (
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
            icon={<FaTrash />}
          >
            Delete Mailshot
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default DeleteMailshotModal;
